(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 78581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_atoms_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51134);
/* harmony import */ var _components_atoms_RichText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36091);
/* harmony import */ var _components_common_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63513);
/* harmony import */ var _components_molecules_Blocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6666);
/* harmony import */ var _components_organisms_Archive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10882);
/* harmony import */ var _functions_getPagePropTypes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23684);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4298);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// Define route post type.
var postType = 'page';
var __N_SSG = true;
/**
 * Render the Page component.
 *
 * @author WebDevStudios
 * @param  {object}  props             The component attributes as props.
 * @param  {boolean} props.archive     Whether displaying single post (false) or archive (true).
 * @param  {boolean} props.dateArchive Whether displaying single post (false) or date-based archive (true).
 * @param  {string}  props.day         Date query: day.
 * @param  {string}  props.month       Date query: month.
 * @param  {object}  props.pagination  Archive pagination data from WordPress.
 * @param  {object}  props.post        Post data from WordPress.
 * @param  {Array}   props.posts       Array of post data from WordPress.
 * @param  {string}  props.year        Date query: year.
 * @return {Element}                   The Page component.
 */ function Page(param) {
    var archive = param.archive, dateArchive = param.dateArchive, day = param.day, month = param.month, pagination = param.pagination, post = param.post, posts = param.posts, year = param.year;
    if (archive) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            seo: _objectSpread({}, post === null || post === void 0 ? void 0 : post.seo),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_Archive__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    posts: posts,
                    postType: "post",
                    pagination: pagination
                })
            })
        }));
    } else if (dateArchive) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            seo: _objectSpread({}, post === null || post === void 0 ? void 0 : post.seo),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_RichText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        tag: "h1",
                        children: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_Archive__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        date: {
                            day: day,
                            month: month,
                            year: year
                        },
                        posts: posts,
                        postType: "post",
                        pagination: pagination
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                id: "gtm",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-PC394CH');\n        "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                type: "module",
                src: "https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                nomodule: true,
                src: "https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                src: "/scripts/frontend_blocks.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                src: "/scripts/frontend_blocks__premium_only.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_7__["default"], {
                src: "https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                seo: _objectSpread({}, post === null || post === void 0 ? void 0 : post.seo),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_Blocks__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    blocks: post === null || post === void 0 ? void 0 : post.blocks
                })
            })
        ]
    }));
};
Page.propTypes = _objectSpread({}, (0,_functions_getPagePropTypes__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(postType), {
    dateArchive: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.bool,
    day: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    month: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    year: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string
});


/***/ }),

/***/ 53678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ HomePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_atoms_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51134);
/* harmony import */ var _components_common_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63513);
/* harmony import */ var _functions_getPagePropTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23684);
/* harmony import */ var _slug___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2769);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Define route post type.
var postType = 'page';
var __N_SSG = true;
/**
 * Render the HomePage component.
 *
 * @author WebDevStudios
 * @param  {object}  props      The component attributes as props.
 * @param  {object}  props.post Post data from WordPress.
 * @return {Element}            The HomePage component.
 */ function HomePage(param) {
    var post = param.post;
    var seo = post.seo, postData = _objectWithoutProperties(post, [
        "seo"
    ]);
    // Display dynamic page data if homepage retrieved from WP.
    if (postData && Object.keys(postData).length > 0) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_slug___WEBPACK_IMPORTED_MODULE_4__["default"], {
            post: post
        }));
    }
    // Display static page content as fallback.
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        seo: _objectSpread({}, seo),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "To display your WordPress homepage dynamically, set your homepage to a static page via the WP dashboard (Settings: Reading Settings)."
                })
            })
        })
    }));
};
HomePage.propTypes = _objectSpread({}, (0,_functions_getPagePropTypes__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(postType));


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [54,5536,2132,6666,9774,2888,179], function() { return __webpack_exec__(78581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);